import { Card, LegacyStack, Page } from "@shopify/polaris";
import { useSmartrrVendorSelector } from "@vendor-app/app/_state/typedVendorReduxHooks";
import React, { useEffect } from "react";

import { MigrationUploadsTable } from "../../../_sharedComponents/FileImports/components/MigrationUploadsTable";
import { DromoContainer } from "@vendor-app/app/_sharedComponents/FileImports/components/DromoContainer";
import { MigrationFileUploadStoreAccess } from "@vendor-app/app/_sharedComponents/FileImports/stores/MigrationFileUpload";

import { dromoMigrationSchemaId } from "@vendor-app/app/_sharedComponents/FileImports/libs/utils/constants";

export const ManualMigration = () => {
  const user = useSmartrrVendorSelector(state => state.auth.user);
  const uploadActions = MigrationFileUploadStoreAccess.useActions();

  useEffect(() => {
    uploadActions.setUser(user);
  }, [!user]);

  return (
    <Page title="Manual migrations">
      <LegacyStack spacing="loose" vertical>
        <Card padding="600">
          <LegacyStack spacing="loose" vertical>
            <DromoContainer schemaId={dromoMigrationSchemaId} uploadType="migration" />
          </LegacyStack>
        </Card>
        <MigrationUploadsTable />
      </LegacyStack>
    </Page>
  );
};
